<div>
    @if (reportApprovalStatus[appraisalStatus()] === "Ubehandlet" || reportApprovalStatus[appraisalStatus()] === "Avvist") { 
        <div class="appraisal-processinginfo">
            <div [class]="{ 'warning-icon': isLatest(), 'info-icon': !isLatest() }"></div>
            <div class="processing-wrapper">
                @if (reportApprovalStatus[appraisalStatus()] === "Ubehandlet") {
                    <h2 class="saleinfo-header">Ubehandlet etakst</h2>
                    <div class="saleinfo-body">etaksten bør godkjennes eller avvises.</div>
                } @else if (reportApprovalStatus[appraisalStatus()] === "Avvist") {
                    <h2 class="saleinfo-header">etaksten er avvist</h2>
                }
            </div>
        </div>
    }

    @if (appraisalHistory()?.length > 0) {
        <div class="appraisal-saleinfo-wrapper">
            <div class="appraisal-saleinfo">
                <h3 class="title">Historikk</h3>
                <div class="appraisal-histories">
                    @for (item of appraisalHistory(); track item; let isLast = $last) {
                        <div class="appraisal-history">
                            <div class="saleinfo-wrapper">
                                <div class="saleinfo-header">
                                    <div class="report-signature">{{ item.signature }}</div>
                                    <div class="report-date">{{ item.createdDate | toShortDateString }}</div>
                                    <div class="report-status">{{ reportApprovalStatus[item.appraisalReportApprovalStatus] }}</div>
                                </div>
                                @if (item?.appraisalDeniedReason) {
                                    <div class="saleinfo-body" [class]="{ last: isLast }">
                                        {{ getAppraisalDeniedDescription(item?.appraisalDeniedReason) }}
                                    </div>
                                } @else if (item?.comment) {
                                    <div class="saleinfo-body" [class]="{ last: isLast }">
                                        {{ item?.comment }}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    
    <section class="detail-grid">
        <div class="col col-1">
            <h3>Nøkkelinfo</h3>
            <div class="keyvalue-pair">
                <div>Boligtype</div>
                <div class="value" [class]="{ changed: detailAppraisal()?.ownershipType_ChangedTo || detailAppraisal()?.estateType_ChangedTo }">
                    {{ detailAppraisal()?.ownershipType }} {{ detailAppraisal()?.estateType }}
                    @if (detailAppraisal()?.ownershipType_ChangedTo || detailAppraisal()?.estateType_ChangedTo) {
                        <div class="new-value">
                            <div class="right-arrow"></div>
                            {{ detailAppraisal()?.ownershipType_ChangedTo }} {{ detailAppraisal()?.estateType_ChangedTo }}
                        </div>
                    }
                </div>
            </div>
            <div class="keyvalue-pair">
                <div>Tomt</div>
                <div class="value" [class]="{ changed: detailAppraisal()?.siteType_ChangedTo || detailAppraisal()?.siteArea_ChangedTo }">
                    {{ detailAppraisal()?.siteType }} {{ detailAppraisal()?.siteArea | areaconverter }}
                    @if (detailAppraisal()?.siteType_ChangedTo || detailAppraisal()?.siteArea_ChangedTo) {
                        <div class="new-value">
                            <div class="right-arrow"></div>
                            {{ detailAppraisal()?.siteType_ChangedTo | defaultconvert }}
                            {{ detailAppraisal()?.siteArea_ChangedTo | areaconverter }}
                        </div>
                    }
                </div>
            </div>
            <div class="keyvalue-pair">
                <div>BRA-i</div>
                <div class="value" [class]="{ changed: detailAppraisal()?.internalUsableArea_ChangedTo }">
                    {{ detailAppraisal()?.internalUsableArea | areaconverter }}
                    @if (detailAppraisal()?.internalUsableArea_ChangedTo) {
                        <div class="new-value">
                            <div class="right-arrow"></div>
                            {{ detailAppraisal()?.internalUsableArea_ChangedTo | areaconverter }}
                        </div>
                    }
                </div>
            </div>
            @if (detailAppraisal()?.internalUsableArea || detailAppraisal()?.internalUsableArea_ChangedTo) {
                <div class="keyvalue-pair">
                    <div>BRA-b</div>
                    <div class="value" [class]="{ changed: detailAppraisal()?.glazedBalconyUsableArea_ChangedTo }">
                        {{ detailAppraisal()?.glazedBalconyUsableArea | areaconverter }}
                        @if (detailAppraisal()?.glazedBalconyUsableArea_ChangedTo) {
                            <div class="new-value">
                                <div class="right-arrow"></div>
                                {{ detailAppraisal()?.glazedBalconyUsableArea_ChangedTo | areaconverter }}
                            </div>
                        }
                    </div>
                </div>
                <div class="keyvalue-pair">
                    <div>BRA-e</div>
                    <div class="value" [class]="{ changed: detailAppraisal()?.externalUsableArea_ChangedTo }">
                        {{ detailAppraisal()?.externalUsableArea | areaconverter }}
                        @if (detailAppraisal()?.externalUsableArea_ChangedTo) {
                            <div class="new-value">
                                <div class="right-arrow"></div>
                                {{ detailAppraisal()?.externalUsableArea_ChangedTo | areaconverter }}
                            </div>
                        }
                    </div>
                </div>
                <div class="keyvalue-pair">
                    <div>ALH</div>
                    <div class="value" [class]="{ changed: detailAppraisal()?.lowHeightFloorArea_ChangedTo }">
                        {{ detailAppraisal()?.lowHeightFloorArea | areaconverter }}
                        @if (detailAppraisal()?.lowHeightFloorArea_ChangedTo) {
                            <div class="new-value">
                                <div class="right-arrow"></div>
                                {{ detailAppraisal()?.lowHeightFloorArea_ChangedTo | areaconverter }}
                            </div>
                        }
                    </div>
                </div>
                <div class="keyvalue-pair">
                    <div>TBA</div>
                    <div class="value" [class]="{ changed: detailAppraisal()?.openTerraceAndBalconyArea_ChangedTo }">
                        {{ detailAppraisal()?.openTerraceAndBalconyArea | areaconverter }}
                        @if (detailAppraisal()?.openTerraceAndBalconyArea_ChangedTo) {
                            <div class="new-value">
                                <div class="right-arrow"></div>
                                {{ detailAppraisal()?.openTerraceAndBalconyArea_ChangedTo | areaconverter }}
                            </div>
                        }
                    </div>
                </div>
            } @else {
                <div class="keyvalue-pair">
                    <div>P-rom</div>
                    <div class="value" [class]="{ changed: detailAppraisal()?.primaryArea_ChangedTo }">
                        {{ detailAppraisal()?.primaryArea | areaconverter }}
                        @if (detailAppraisal()?.primaryArea_ChangedTo) {
                            <div class="new-value">
                                <div class="right-arrow"></div>
                                {{ detailAppraisal()?.primaryArea_ChangedTo | areaconverter }}
                            </div>
                        }
                    </div>
                </div>
                <div class="keyvalue-pair">
                    <div>BRA</div>
                    <div class="value" [class]="{ changed: detailAppraisal()?.utilityFloorSpace_ChangedTo }">
                        {{ detailAppraisal()?.utilityFloorSpace | areaconverter }}
                        @if (detailAppraisal()?.utilityFloorSpace_ChangedTo) {
                            <div class="new-value">
                                <div class="right-arrow"></div>
                                {{ detailAppraisal()?.utilityFloorSpace_ChangedTo | areaconverter }}
                            </div>
                        }
                    </div>
                </div>
                <div class="keyvalue-pair">
                    <div>BTA</div>
                    <div class="value" [class]="{ changed: detailAppraisal()?.grossArea_ChangedTo }">
                        {{ detailAppraisal()?.grossArea | areaconverter }}
                        @if (detailAppraisal()?.grossArea_ChangedTo) {
                            <div class="new-value">
                                <div class="right-arrow"></div>
                                {{ detailAppraisal()?.grossArea_ChangedTo | areaconverter }}
                            </div>
                        }
                    </div>
                </div>
            }
            <div class="keyvalue-pair">
                <div>Etasje</div>
                <div class="value" [class]="{ changed: detailAppraisal()?.floor_ChangedTo }">
                    {{ detailAppraisal()?.floor | defaultconvert }}
                    @if (detailAppraisal()?.floor_ChangedTo) {
                        <div class="new-value">
                            <div class="right-arrow"></div>
                            {{ detailAppraisal()?.floor_ChangedTo }}
                        </div>
                    }
                </div>
            </div>
            <div class="keyvalue-pair">
                <div>Soverom</div>
                <div class="value" [class]="{ changed: detailAppraisal()?.bedrooms_ChangedTo }">
                    {{ detailAppraisal()?.bedrooms | defaultconvert }}
                    @if (detailAppraisal()?.bedrooms_ChangedTo) {
                        <div class="new-value">
                            <div class="right-arrow"></div>
                            {{ detailAppraisal()?.bedrooms_ChangedTo }}
                        </div>
                    }
                </div>
            </div>
            <div class="keyvalue-pair last">
                <div>Fellesgjeld
                    @if (detailAppraisal()?.currentCommonDebtUpdatedDate) {
                         per {{ detailAppraisal()?.currentCommonDebtUpdatedDate | toShortDateString }}
                    }
                </div>
                <div class="value" [class]="{ changed: detailAppraisal()?.currentCommonDebtUpdatedDate }">
                    {{ detailAppraisal()?.currentCommonDebt | thousandize }}
                </div>
            </div>
        </div>

        <div class="col col-2">
            <h3>Tilleggsinfo</h3>
            @if (detailAppraisal()?.skipPrice) {
                <div>
                    <div class="realestate-input-header">Siste omsetningsverdi er ikke hensyntatt pga:</div>
                    <div class="realestate-input-body">
                        {{ detailAppraisal()?.skipPriceReason }}
                        {{ detailAppraisal()?.skipPriceReasonDetail }}
                    </div>
                </div>
            }
            @if (detailAppraisal()?.informationToBank) {
                <div class="realestate-input-body">
                    <div class="realestate-input-header">Info til bank</div>
                    {{ detailAppraisal()?.informationToBank }}
                </div>
            }
        </div>

        <div class="col col-3">
            <h3>Referanse</h3>
            <div>
                <div class="keyvalue-pair">
                    <div>Ref</div>
                    <div>{{ detailAppraisal()?.appraisalRefId }}</div>
                </div>
                <div class="keyvalue-pair">
                    <div>Befart</div>
                    <div>{{ detailAppraisal()?.inspectionDate | toShortDateString }}</div>
                </div>
                <div class="keyvalue-pair">
                    <div>Oppdragsgiver</div>
                    <div>{{ detailAppraisal()?.contractName }}</div>
                </div>
                <div class="keyvalue-pair no-underline">
                    <div>Megler</div>
                    <div>{{ detailAppraisal()?.agentName }}</div>
                </div>
                <div class="keyvalue-pair agent-office">
                    <div >{{ detailAppraisal()?.agentOffice }}</div>
                </div>
                <div class="keyvalue-pair rangebar">
                    <div class="key">Standard etter tiltak</div>
                    <div>
                        <ev-rangebar [highlighted]="detailAppraisal()?.estateQuality" [length]="5" [minimalistic]="true"></ev-rangebar>
                    </div>
                </div>
                <div class="keyvalue-pair rangebar last">
                    <div class="key">Lokal beliggenhetsfaktor</div>
                    <div>
                        <ev-rangebar [highlighted]="detailAppraisal()?.locationFactor" [length]="5" [minimalistic]="true"></ev-rangebar>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
